Controller.$inject = [];

function Controller() {

}

export function HuiProgressGroupLine() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui-progress-group-line" ng-transclude></div>
            `;
        }
    }
}